import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import { Box, IconButton } from '@mui/material';
import React from 'react';
import { useHistory } from 'react-router';
import Images from '../../Assets/assetHelper';
import routes from '../../Utils/routes';
import { ReactChildren } from '../../interfaces/Common';
import { useStyles } from '../AppLayout/styles';
import AppBreadCrumbs from '../BreadCrumbs';
import GoBackIcon from '../GoBackIcon';

const NestedPageLayout: React.FunctionComponent<ReactChildren> = ({ children }) => {
  const navigate = useHistory();
  const classes = useStyles();
  return (
    <Box sx={{ height: '100vh', overflow: 'hidden', background: '#FFF' }}>
      <Box sx={{ borderBottom: '1px solid #F0EDF6', height: '8%' }}>
        <Box className={classes.header} style={{ boxShadow: 'none' }}>
          <Box className={classes.mobileHeaderContainer}>
            <GoBackIcon needBGgColor={false} />
            <Box>
              <AppBreadCrumbs />
            </Box>
            <Box sx={{ gap: '10px' }}>
              <IconButton onClick={() => navigate.push(routes.notifcation)}>
                <img src={Images.Icons.notificationIcon} alt="" />
              </IconButton>
              <IconButton sx={{ background: '#F0EDF6' }} onClick={() => navigate.push(routes.chat)}>
                <ChatBubbleOutlineOutlinedIcon sx={{ fontSize: '16px', color: '#604797' }} />
              </IconButton>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box sx={{ background: '#FFF', height: '92%', overflow: 'auto' }}>
        <Box sx={{ m: '10px 16px ' }}>{children}</Box>
      </Box>
    </Box>
  );
};

export default NestedPageLayout;
